export const LANGUAGES_OPTIONS = Object.freeze([
  {
    value: 'en',
    label: 'EN',
  },
  {
    value: 'sr',
    label: 'SR',
  },
  {
    value: 'ru',
    label: 'RU',
  },
  {
    value: 'sq',
    label: 'SQ',
  },
  {
    value: 'pl',
    label: 'PL',
  },
  {
    value: 'zh',
    label: 'ZH',
  },
]);

export const LOCALE_MAP = Object.freeze({
  en: 'en-GB',
  sr: 'sr-RS',
  ru: 'ru-RU',
  sq: 'sq-AL',
  pl: 'pl-PL',
  zh: 'zh-CN',
});

export const FALLBACK_LNG = Object.freeze('en');

export const SUPPORTED_LNGS = Object.freeze(['en', 'sr', 'ru', 'sq', 'pl', 'zh']);
